




import Vue from 'vue';

export default Vue.extend({
  name: 'CurrencyInput',
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      textVal: this.value?.toFixed(2),
    };
  },
  computed: {
    parsedNumber: {
      get(): string {
        return this.value.toFixed(2);
      },
      set(newVal: string) {
        const parsed = parseFloat(newVal);
        if (!isNaN(parsed)) {
          this.$emit('input', parsed);
        } else {
          this.$forceUpdate();
        }
      },
    },
  },
  watch: {
    textVal(newVal: string, oldVal: string) {
      const parsed = parseFloat(newVal);
      if (isNaN(parsed)) {
        this.textVal = oldVal;
      } else {
        this.textVal = parsed.toFixed(2);
      }
    },
  },
  methods: {
    filterKeys(evt: KeyboardEvent) {
      const allowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
        'Backspace', 'Delete', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'ArrowDown', 'Tab'];
      const pressed = evt.key;
      if (!allowed.includes(pressed)) {
        evt.preventDefault();
      }
    },
  },
});
